// 艺培相关接口
import request from '@/utils/request'

// 线上培训详情
export function onlineDetail(id) {
  return request({
    url: `/cultureCantonDemoApi/artTrainBasicInfoApi/onlineDetail?id=${id}`,
    method: 'get',
  })
}

// 线下培训详情
export function offlineDetail(data) {
  return request({
    url: `/cultureCantonDemoApi/artTrainBasicInfoApi/offlineDetail?id=${data.id}&longitude=${data.longitude}&latitude=${data.latitude}`,
    method: 'get',
  })
}

// 报名线下课程
export function artTrainSignUp(data) {
  return request({
    url: '/cultureCantonDemoApi/artTrainBasicInfoApi/enroll',
    method: 'post',
    data,
  })
}

// 保存观看进度
export function saveVideoLog(data) {
  return request({
    url: '/cultureCantonDemoApi/artTrainBasicInfoApi/saveVideoLog',
    method: 'post',
    data,
  })
}
